<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a><a id="page_iii"></a>
<h1 class="title">The American Way</h1>
<p class="subtitle">Franklin D. Roosevelt</p>
<p class="subtitle1">Edited by Dagobert D. Runes</p>
<div class="img_containerc">
<img alt="image" src="images/Philosophical_Library_logo.jpg"/>
</div>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?2122289a